import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Layers, FileText } from 'lucide-react';

const ViewToggle = ({ viewMode, onToggle }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className={`inline-flex rounded-xl p-1 ${isDark ? 'bg-white/5' : 'bg-slate-100'}`}>
      <button
        onClick={() => onToggle('plan')}
        data-testid="view-by-plan-btn"
        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all
          ${viewMode === 'plan'
            ? 'bg-emerald-500 text-white shadow-lg'
            : isDark
              ? 'text-slate-400 hover:text-white hover:bg-white/5'
              : 'text-slate-600 hover:text-slate-900 hover:bg-white'
          }`}
      >
        <FileText className="w-4 h-4" />
        By Plan
      </button>
      <button
        onClick={() => onToggle('group')}
        data-testid="view-by-group-btn"
        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all
          ${viewMode === 'group'
            ? 'bg-emerald-500 text-white shadow-lg'
            : isDark
              ? 'text-slate-400 hover:text-white hover:bg-white/5'
              : 'text-slate-600 hover:text-slate-900 hover:bg-white'
          }`}
      >
        <Layers className="w-4 h-4" />
        By Plan Group
      </button>
    </div>
  );
};

export default ViewToggle;
